import useMasterContext from "Context/MasterContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useState, useContext, useEffect } from "react";
import {
  BASE_URL,
  MY_BATCHES_LIST,
  GET_PHX_USER_DETAILS,
  GET_BATCH_COURSES_CHAPTER_VIEW,
  GET_LECTURE_DETAIL,
} from "utilFunctions/Constants/urlConstants";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { useLocation } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import MyBatchesFacultyDetailTab from "Pages/MyBatches/MyBatchesFacultyDetailTab";
import MyProfilePhoenixDetails from "Pages/MyProfile/MyProfilePhoenixDetails";
import { SINGLE_USER } from "utilFunctions/Constants/urlConstants";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import MyBatchesTableAntd from "Pages/MyBatchesAntd/MyBatchesTableAntd";
import { StyledMainDiv } from "Pages/MyBatchesAntd/MyBatchesAntd";
import FacultyBatchHeader from "Pages/FacultiesAntd/FacultyBatch/FacultyBatchHeader";
import { LectureChapterArr } from "utilFunctions/Constants/Constants";
import styled from "styled-components";
import { Tabs } from "antd";
import {
  addDays,
  format,
  setHours,
  setMinutes,
  setSeconds,
  subDays,
} from "date-fns";
import MyBatchLecturesTab from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchLecturesTab";
import moment from "moment";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
const CustomTabs = styled<any>(Tabs)`
  .ant-tabs-nav {
    margin: 0px !important;
    background: white;
    border-radius: 8px;
    padding-left: 12px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #1677ff !important;
    font-weight: 600 !important;
  }
  .ant-tabs-tab-btn {
    font-size: 14px !important;
    // font-weight: 600 !important;
  }
`;
export const BranchStudentTableHeading = [
  { label: "Batch Name", value: "batchName" },
  { label: "Class", value: "class" },
  { label: "Subject", value: "subject" },
  { label: "Syllabus Status", value: "plLecStatus" },
  { label: "Upcoming Tests", value: "testType" },
  { label: "Test Syllabus Status", value: "testSyllbStatus" },
  { label: "Unmarked lectures", value: "unMarkedLectureCount" },
  { label: "Total Students", value: "totalNumberOfStudents" },
  { label: "Marked Attendance %", value: "markedAttdCount" },
  { label: "Action", value: "action" },
];
const date = new Date();
const month = String(date.getMonth() + 1); // Months are 0-based, so we add 1
const year = String(date.getFullYear()).slice(-2); // Get the last two digits of the year
const FacultyBatch = () => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const [searchedFaculty] = useState<any>(null);
  const { masters } = useMasterContext();
  const location = useLocation();
  const { state } = location;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [refresh, setRefresh] = useState<any>(false);
  const [BATCHData, setBATCHData] = useState<any>([]);
  const [facultyDetail, setfacultyDetail] = useState<any>(null);
  const { faculty } = state;
  const [facid, setFacid] = useState<any>(
    faculty?.employeeId
      ? faculty?.employeeId
      : faculty?.facultyId
      ? faculty?.facultyId
      : userInfo?.employeeId
  );
  const [facultyDetailPHX, setfacultyDetailPHX] = useState<any>(null);
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    state && state?.selectedDefaultTab && state?.selectedDefaultTab != null
      ? state?.selectedDefaultTab
      : "1"
  );
  useEffect(() => {
    if (
      state &&
      state?.selectedDefaultTab &&
      state?.selectedDefaultTab != null
    ) {
      setSelectedTabIndex(state?.selectedDefaultTab);
      if (state?.selectedDefaultTab === "3") {
        trackLectureStatusTabView();
      }
    }
  }, [state]);
  const startDate = new Date(
    format(
      setSeconds(setMinutes(setHours(subDays(new Date(), 7), 18), 30), 0),
      "yyyy-MM-dd"
    )
  );
  const endDate = new Date(
    format(
      setSeconds(setMinutes(setHours(addDays(new Date(), 0), 0), 30), 0),
      "yyyy-MM-dd"
    )
  );
  const [dateRanges, setDateRanges] = useState([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);
  const [filterState, setFilterState] = useState<any>({
    type: "plannedLectures",
    chipFields: {
      type: "Planned Lectures",
    },
  });
  const [filterStateLectureStatus, setFilterStateLectureStatus] = useState<any>(
    {
      batchIds: null,
      dateRange:
        moment(startDate).format("YYYY-MM-DD") +
        "~" +
        moment(endDate).format("YYYY-MM-DD"),
      subject: null,
      attendanceStatus: null,
      status: null,
      chipFields: {
        dateRange:
          moment(startDate).format("YYYY-MM-DD") +
          "~" +
          moment(endDate).format("YYYY-MM-DD"),
      },
    }
  );
  const [open, setOpen] = useState<boolean>(false);
  const { screen }: any = useWindowSize();
  const [selectedType, setSelectedType] = useState({
    label: "Planned Lectures",
    value: "plannedLectures",
  });
  const [chapterData, setChapterData] = useState<any>([]);

  const { makeRequest: GetBATCHDATA, loading } = useGetApi(
    (data) => {
      console.log("isBATCHData", data, data["data"]);
      if (data?.data?.batchResposeList?.length) {
        setBATCHData(data["data"]["batchResposeList"]);
      } else {
        setBATCHData([]);
      }
    },
    (error) => {
      setBATCHData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const { makeRequest: GetFacultyData } = useGetApi(
    (data) => {
      console.log("GetFacultyData", data);
      if (
        data["data"] &&
        data["data"]["response"] &&
        data["data"]["response"].length
      ) {
        setfacultyDetail(data["data"]["response"][0]);
      }
    },
    (error) => {
      setfacultyDetail(null);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );

  const { makeRequest: GetFacultyDataFromPHX } = useGetApi(
    (data) => {
      if (data["data"]) {
        setfacultyDetailPHX(data["data"]);
      }
    },
    (error) => {
      setfacultyDetailPHX(null);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const { makeRequest: GetBatchCoursesChapterView } = useGetApi(
    (data) => {
      if (data && data["data"] && data["data"].length) {
        setBATCHData(setChapterHandler(BATCHData, data["data"]));
        setChapterData(data["data"]);
      } else {
        setChapterData([]);
      }
    },
    (error) => {
      setChapterData([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const setChapterHandler = (batches: any, chapterList: any) => {
    const arr = batches.map((ele: any) => {
      const el = chapterList.find((el: any) => el.batchId === ele.batchId);
      if (el) {
        return { ...ele, chapterData: el };
      }
      return ele;
    });
    return arr;
  };
  useEffect(() => {
    let url = BASE_URL + MY_BATCHES_LIST + "?month=" + month + "&year=" + year;
    if (
      localStorage.getItem("myBatchsFilter") &&
      JSON.parse(localStorage.getItem("myBatchsFilter") as any)
    ) {
      const parsedFilter: any = JSON.parse(
        localStorage.getItem("myBatchsFilter") as any
      );
      url = url + "&facultyId=" + parsedFilter?.employeeId;
      setFacid(parsedFilter?.employeeId);
      GetBATCHDATA(url);
    } else {
      const { faculty } = state;
      const facultyId =
        location.pathname.split("/")[location.pathname.split("/").length - 1] ||
        "";
      let employeeId =
        state.selectedStudent && state.selectedStudent !== null
          ? state.selectedStudent.employeeId
          : faculty?.employeeId;
      if (facultyId != "batches" && state) {
        if (faculty?.employeeId) {
          setFacid(faculty?.employeeId);
          employeeId = faculty?.employeeId;
          url = url + "&facultyId=" + faculty?.employeeId;
        } else if (faculty?.facultyId) {
          setFacid(faculty?.facultyId);
          employeeId = faculty?.facultyId;
          url = url + "&facultyId=" + faculty?.facultyId;
        } else {
          employeeId = state?.selectedStudent?.employeeId;
          setFacid(state?.selectedStudent?.employeeId);
          url = url + "&facultyId=" + state?.selectedStudent?.employeeId;
        }
        GetBATCHDATA(url);
        const singleUrl = BASE_URL + SINGLE_USER + "/search?id=" + facultyId;
        GetFacultyData(singleUrl);
        const phxUrl =
          BASE_URL +
          GET_PHX_USER_DETAILS +
          "?facultyNameOrfacultyId=" +
          employeeId;
        GetFacultyDataFromPHX(phxUrl);
      } else if (searchedFaculty) {
        url = url + "&facultyId=" + searchedFaculty;
        setFacid(searchedFaculty);
        GetBATCHDATA(url);
      } else if (userInfo?.employeeId && userInfo?.employeeId != null) {
        url = url + "&facultyId=" + userInfo?.employeeId;
        setFacid(userInfo?.employeeId);
        GetBATCHDATA(url);
      } else {
        console.log(userInfo);
      }
    }
  }, [userInfo, searchedFaculty, location]);

  const applyFilter = (selectedType: any) => {
    if (selectedTabIndex == "1") {
      onSelectedChange(selectedType);
    } else {
      setFilterStateLectureStatus((prevFilterStateLectureStatus: any) => ({
        ...prevFilterStateLectureStatus,
        ...selectedType,
        chipFields: {
          ...prevFilterStateLectureStatus.chipFields,
          ...selectedType,
        },
      }));
      setRefresh(new Date().getMilliseconds());
      const updatedFilters = { ...filterStateLectureStatus, ...selectedType };
      const batchname = BATCHData.find((ele: any) =>
        updatedFilters?.batchIds
          ? ele.batchId === updatedFilters?.batchIds
          : null
      )?.batchName;
      const lectureStatusFilterEvent = {
        event: "ag_fp_view_faculty_lecture_status_tab",
        EMPLOYEE_ID: facid ?? "",
        BATCH: batchname ?? "",
        SUBJECT: updatedFilters?.subject ?? "",
        SYLLABUS_COMPLIANCE_STATUS: updatedFilters?.status ?? "",
        ATTENDANCE_STATUS: updatedFilters?.attendanceStatus ?? "",
        DATE_RANGE: updatedFilters?.dateRange ?? "",
      };
      pushToDataLayerForGTM(lectureStatusFilterEvent);
    }
  };
  const items = [
    {
      key: "1",
      name: "Batch Details",
      label: "Batch Details",
      value: "batchDetails",
      filterListing: [],
      children: (
        <TableLayoutAntd isLoader={loading}>
          <MyBatchesTableAntd
            data={BATCHData}
            access={[
              "batchName",
              "class",
              "subject",
              "plLecStatus",
              "plLecStatusSyllabus",
              "testType",
              "testSyllbStatus",
              "unMarkedLectureCount",
              "totalNumberOfStudents",
              "markedAttdCount",
              "action",
            ]}
            setData={setBATCHData}
          ></MyBatchesTableAntd>
        </TableLayoutAntd>
      ),
    },
    {
      key: "2",
      name: "Faculty Details",
      label: "Faculty Details",
      value: "facultyDetails",
      filterListing: [],
      children: (
        <>
          <MyBatchesFacultyDetailTab
            route={"myprofile"}
            facultyDetail={facultyDetail}
            screen={screen}
            branches={masters?.branches}
            regions={masters?.regions}
            streams={masters?.streams}
            subjects={masters}
          />
          <MyProfilePhoenixDetails
            route={"myprofile"}
            facultyDetail={facultyDetailPHX}
            screen={screen}
            branches={masters?.branches}
            regions={masters?.regions}
            streams={masters?.streams}
            subjects={masters}
          />
        </>
      ),
    },
    {
      key: "3",
      name: "Lecture Status",
      label: "Lecture Status",
      value: "lectureStatus",
      filterListing: [],
      children: (
        <>
          <MyBatchLecturesTab
            module={"facultyLectureStatus"}
            ModuleUrl={GET_LECTURE_DETAIL}
            BATCHData={BATCHData}
            selectedCourseSyllabus={{}}
            batchDetailsData={null}
            screen={screen}
            filterState={filterStateLectureStatus}
            refresh={refresh}
            dateRanges={dateRanges}
            setFilterState={setFilterStateLectureStatus}
            applyFilter={applyFilter}
            filterListing={["status", "subjectList", "date"]}
            facid={facid}
          ></MyBatchLecturesTab>
        </>
      ),
    },
  ];
  const onSelectedChange = (value: any) => {
    setSelectedType(value);
    setFilterState({
      type: value,
      chipFields: {
        type: LectureChapterArr.find((ele: any) => ele.value === value)?.label,
      },
    });
    setOpen(false);
    if (value == "chapter") {
      if (chapterData.length) {
        setBATCHData(setChapterHandler(BATCHData, chapterData));
      } else {
        const arr = BATCHData.map((ele: any) => ele.plLecStatus)
          .filter((ele: any) => ele != null)
          .map((ele: any) => ele.batchCourseId);
        GetBatchCoursesChapterView(
          BASE_URL +
            GET_BATCH_COURSES_CHAPTER_VIEW +
            "?batchCourseIds=" +
            arr.toString()
        );
      }
    } else {
      setBATCHData(
        BATCHData.map((ele: any) => ({ ...ele, chapterData: null }))
      );
    }
  };
  const trackLectureStatusTabView = () => {
    const lectureStatusTabEvent = {
      event: "ag_fp_view_faculty_lecture_status_tab",
      EMPLOYEE_ID: facid ?? "",
      BATCH_ID: filterStateLectureStatus?.batchIds ?? "",
      SUBJECT: filterStateLectureStatus?.subject ?? "",
      SYLLABUS_COMPLIANCE_STATUS: filterStateLectureStatus?.status ?? "",
      ATTENDANCE_STATUS: filterStateLectureStatus?.attendanceStatus ?? "",
      DATE_RANGE: filterStateLectureStatus?.dateRange ?? "",
    };
    pushToDataLayerForGTM(lectureStatusTabEvent);
  };
  const onChange = (key: string) => {
    setSelectedTabIndex(key);
    if (key === "3") {
      trackLectureStatusTabView();
    }
  };
  return (
    <StyledMainDiv screen={screen}>
      <FacultyBatchHeader
        setFilterState={setFilterState}
        filterState={
          selectedTabIndex == "3" ? filterStateLectureStatus : filterState
        }
        applyFilter={applyFilter}
        open={open}
        setOpen={setOpen}
        onSelectedChange={(value: any) => setSelectedType(value)}
        selectedType={selectedType}
        selectedTabIndex={selectedTabIndex}
        facultyDetail={facultyDetail}
        setFilterStateLectureStatus={setFilterStateLectureStatus}
        BATCHData={BATCHData}
        startDate={startDate}
        endDate={endDate}
        dateRanges={dateRanges}
        setDateRanges={setDateRanges}
        filterListing={
          selectedTabIndex == "3"
            ? ["batchIds", "subject", "dateRange", "status", "attendanceStatus"]
            : []
        }
      />
      <CustomTabs
        activeKey={selectedTabIndex}
        defaultActiveKey={selectedTabIndex}
        items={items}
        onChange={onChange}
        destroyInactiveTabPane={true}
      />
    </StyledMainDiv>
  );
};

export default FacultyBatch;
